import React, { Component } from "react";
import { connect } from "react-redux";
import FloatingTransferTable from "./FloatingTransfer";

import { Layout, Breadcrumb } from "antd";
const { Content } = Layout;

class Dashboard extends Component {
  render() {
    return (
      <>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Floating Transfer Item</Breadcrumb.Item>
        </Breadcrumb>
        <div className="site-layout-background main-frame">
          <FloatingTransferTable />
        </div>
      </>
    );
  }
}

export default connect()(Dashboard);


